import { render } from "./NaturalFarming.vue?vue&type=template&id=6dd50104&ts=true"
import script from "./NaturalFarming.vue?vue&type=script&lang=ts"
export * from "./NaturalFarming.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__